// import _ from 'lodash'
import { adminClient as apolloClient } from '@/store/apollo';

import PurchaseStatusesGql from '@/extensions/shop/store/graphql/queries/PurchaseStatuses.gql';

export default {
    fetchList: () =>
        new Promise((resolve, reject) => {
            let variables = {};

            apolloClient
                .query({
                    query: PurchaseStatusesGql,
                    variables
                })
                .then(({ data }) => resolve(data.CO_PurchaseStatuses))
                .catch(err => reject(err));
        })
};
